<!--
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2022-12-05 15:00:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-21 18:41:53
 * @FilePath: \common_web\src\views\archiveManager\report.vue
-->
<template>
  <div class="leaseContract">
    <transition :name="transitionName" mode="out-in">
      <div v-if="!detail">
        <div class="search">
          <div class="tab">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane :label="$t('applyChild.all')" name="1"></el-tab-pane>
              <el-tab-pane :label="$t('archiveManagerReport.running')" name="3"></el-tab-pane>
              <el-tab-pane :label="$t('archiveManagerReport.notRunned')" name="2"></el-tab-pane>
            </el-tabs>
          </div>
          <el-input
            :placeholder="$t('applyChild.pleInputCon')"
            v-model="input3"
            class="input-with-select"
          >
            <el-button
              slot="append"
              type="primary"
              @click="search"
              icon="el-icon-search"
              >{{$t('tagsView.search')}}</el-button
            >
          </el-input>
        </div>

        <div class="content">
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, i) in tableData" :key="i">
              <div class="list">
                <div class="devinfo" @click="lookdetail(item)">
                  <div class="devinfo_left">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.shopPhoto"
                    >
                    </el-image>
                  </div>
                  <div class="devinfo_right">
                    <p class="bold">
                      <span>{{ item.name }}</span>
                      <span>{{ item.statusName }}</span>
                    </p>
                    <p>
                      {{$t('archiveManagerList.totalRunTime')}}：<span>{{ item.useDurationHours + "h" }}</span>
                    </p>
                    <p>
                      {{'archiveManagerReport.totalRunFrequency'}}：<span>{{ item.useCount }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-empty :image-size="200" v-if="tableData.length < 1"></el-empty>
        </div>
        <div class="page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totals"
          >
          </el-pagination>
        </div>
      </div>
      <!-- <LeaseContractDetail
        v-if="detail"
        @goblack="goblack"
        :id="id"
       
      /> -->
      <div v-if="detail">
        <div class="head">
          <i class="i1"></i><i class="i2"></i>
          <div class="con">{{checkdev.name}}</div>
          <el-button type="primary" size="mini" @click="goblack"
            >{{$t('applyChildDetail.return')}}</el-button
          >
        </div>
        <div class="tablist">
          <div class="totalList">
            <div class="total">
              <span class="label">{{$t('archiveManagerList.totalRunTime')}}：</span>
              <div class="col">
                <span class="num">{{ restotal.sumDuration }}</span>
              </div>
            </div>
            <div class="total">
              <span class="label">{{$t('archiveManagerReport.totalRunFrequency')}}：</span>
              <div class="col">
                <span class="num">{{ restotal.sumCount }}h</span>
              </div>
            </div>
          
          </div>
          <el-table :data="tableData1" stripe style="width: 100%">
            <el-table-column
              prop="index"
              align="center"
              :label="$t('archiveManagerMachive.serialNum')"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="useTimeHours"
              align="center"
              :label="$t('archiveManagerReport.runTime')"
            >
            </el-table-column>
            <el-table-column prop="createTime" align="center" :label="$t('archiveManagerMachive.date')">
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="page1.current"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="page1.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totals1"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { listRunTime, shopDevicelistByTime, intermediaryMachinehourReport } from "@/api/archive.js";
import LeaseContractDetail from "./leaseContractDetail.vue";
export default {
  data() {
    return {
      tableData: [],
      page: {
        current: 1,
        size: 10,
      },
      intermediary: false,
      totals: 0,
      input3: "",
      transitionName: "fade",
      detail: false,
      checkdev: "",
      activeName: "1",
      page1: {
        current: 1,
        size: 10,
      },
      totals1: 0,
      tableData1: [],
      code: "",
      restotal: "",
    };
  },
  components: {
    LeaseContractDetail,
  },
  mounted() {
    console.log(this)
    this.code = this.$route.query.id;
    this.intermediary = this.$route.query.intermediary?true:false;
    this.getlistRunTime();
  },
  methods: {
    handleClick(e) {
      console.log(e, this.activeName, '--actionvanme')
      if (this.activeName == '0') {
         this.activeName = ''
      }
        this.getlistRunTime()
    },
    getlistRunTime() {
      let obj = { ...this.page, shopCode: this.code,status: this.activeName*1>1?this.activeName : '' }
      // debugger
      if (this.intermediary) {
        intermediaryMachinehourReport(obj).then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.records;
            this.totals = res.data.data.total;
            this.page.current = res.data.data.current;
          }
        });
      } else {
        listRunTime(obj).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.totals = res.data.data.total;
          this.page.current = res.data.data.current;
        }
      });
    }
    },
    search() {},
    handleSizeChange(e) {},
    handleCurrentChange(e) {},
    handleSizeChange1(e) {},
    handleCurrentChange1(e) {},
    goblack() {
      this.detail = false;
    },
    lookdetail(info) {
      this.checkdev = info;
      this.getshopDevicelistByTime();
      this.$nextTick(() => {
        this.detail = true;
      });
    },
    getshopDevicelistByTime() {
      let obj = {
        ...this.page1,
        tenantId: this.checkdev.tenantId,
        shopCode: this.checkdev.shopCode,
        mac: this.checkdev.mac,
        // phoneTime: "2022-12-07",
      };
      shopDevicelistByTime(obj).then((res) => {
        if (res.data.code == 200) {
          if (res.data.code == 200) {
            res.data.data.records.map((v, i) => {
              v.index = i + 1;
            });
            this.restotal = res.data.data;
            this.tableData1 = res.data.data.records;
            this.totals1 = res.data.data.total;
            this.page1.current = res.data.data.current;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" >
.leaseContract {
  background: #f2f6f9;
  height: 100%;
  overflow-y: auto;

  overflow-x: hidden;
  .totalList {
    display: flex;
    height: 40px;
    align-items: center;
  }
  .total {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  .total:not(:first-child) {
    margin-left: 20px;
  }
  .label {
    color: #999999;
  }
  .col {
    color: #fd894a;
  }

.search {
  // display: flex;
  background: #fff;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .input-with-select {
    width: 20%;
  }
  .tab {
    // display: flex;
    flex: 1;
    background: #fff;
    padding: 0px 25px;
    .el-tabs__header {
      margin: 0;
    }
  }
}
.head {
  display: flex;
  width: 100%;
  flex: 1;
  margin-top: 10px;
  align-items: center;
  .i1 {
    width: 4px;
    height: 18px;
    background: #50c4cb;
    border-radius: 1px;
    margin-right: 2px;
    display: inline-block;
  }
  .i2 {
    width: 2px;
    height: 18px;
    background: #50c4cb;
    border-radius: 1px;
    display: inline-block;
  }
  .con {
    flex: 1;
    font-size: 18px;
    color: #333;
    font-weight: bold;
    margin-left: 10px;
  }
}
.tablist {
  padding: 20px 0;
}
.content {
  .list {
    background: #fff;
    padding-bottom: 10px;
    margin-bottom: 15px;
    .bnt {
      padding: 0 20px;
      text-align: end;
    }
  }

  .bold {
    font-weight: bold;
    line-height: 32px;
    // padding: 0 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .devinfo {
    padding: 15px 25px 15px 25px;

    display: flex;

    border-radius: 4px;
    align-items: center;

    &_left {
      width: 120px;
      height: 140px;
      margin-right: 20px;
    }
    &_right {
      height: 140px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      p {
        flex: 1;
        display: flex;
        width: 100%;
        font-size: 14px;
        align-items: center;
        // justify-content: space-between;
      }
    }
  }
}
.page {
  margin: 20px 0;
  text-align: end;
}
}
</style>